<template>
	<v-dialog
		class="dialog"
		v-model="dialogVisible"
		:max-width="maxWidth"
	>
		<v-card class="pb-3">
			<v-alert dense class="mx-3 my-0" type="error" v-if="error_msg.length !== 0">
				{{ errorMessageFormat(error_msg) }}
			</v-alert>
			<ProgressLinear v-if="loading"/>
			<template v-else>
				<v-row class="ma-0 title-text px-3" style="height: 48px;" justify="space-between" align="center">
					<div>
						<span>Media Ref ID:</span>
						<span>{{ refId }}</span>
					</div>
					<v-btn icon @click="dialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-row>
				<v-divider></v-divider>
				<template v-if="historyDetail.length === 0">
					<v-row class="ma-0 px-4 py-4" align="center">
						<span class="context-text">No logs</span>
					</v-row>
				</template>
				<template v-else>
					<div v-for="(history, index) in historyDetail" :key="history.id">
						<v-row class="ma-0 px-4" :class="history.booking ? 'pt-2 pb-0':'py-4'" align="center">
							<span class="time-text">{{ history.time }}&nbsp;&nbsp;</span>
							<span class="context-text">{{ history.user_name }}&nbsp;&nbsp;</span>
							<span v-if="!history.booking" class="context-text">
								<span>{{ history.log[0] }}&nbsp;&nbsp;</span>
								<span style="font-weight: 700">{{ history.log_status }}</span>
							</span>
						</v-row>
						<template v-if="history.booking">
							<v-row class="ma-0 px-4" v-for="(log, index) in history.log" :key="`${index}_${log.key}`">
								<v-row v-if="typeof(log) === 'string'" class="ma-0 py-4">
									<span class="context-text">{{ log }}</span>
								</v-row>
								<v-col v-if="typeof(log) === 'object'" cols="6" class="py-1" align-self="center">
									<span>{{ log.key }}: </span>
								</v-col>
								<v-col v-if="typeof(log) === 'object'" cols="6" class="py-1 d-flex align-center flex-nowrap">
									<span class="context-text">{{ log.last }}</span>
									<v-icon class="mx-3" size="16" color="#192A3E">mdi-arrow-right</v-icon>
									<span class="context-text" style="font-weight: 700">{{ log.current}}</span>
								</v-col>
							</v-row>
						</template>
						<v-divider v-if="index !== (historyDetail.length - 1)"></v-divider>
					</div>
				</template>
			</template>
		</v-card>
	</v-dialog>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import moment from 'moment';

const Error_Flag = 'Traffic;';

export default {
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		refId: {
			type: String,
			default: ''
		},
		maxWidth: {
			type: Number,
			default: 600
		}
	},
	components: {
		ProgressLinear
	},
	data() {
		return {
			loading: false,
			error_msg: '',

			history_log: [],
		}
	},
	created() {
		if (this.refId.length !== 0) {
			this.getHistoryByRefID(this.refId);
		}
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit('input', value);
			}
		},
		historyDetail() {
			let log = [];

			if (this.history_log.length !== 0) {
				log = [...this.history_log];
				log.sort((history_a, history_b) => {
					const time_a = moment(history_a.logged_datetime);
					const time_b = moment(history_b.logged_datetime);
					return time_b.valueOf() - time_a.valueOf();
				});

				log.forEach(l => { 
					l['user_name'] = l.user.display_name;
					l['time'] = moment(l.logged_datetime).format('DD MMM hh:mm a');

					if (l.booking_id === null) {
						l['booking'] = false;
						const logs = l.log_info.split(':');
						l['log'] = [`${logs[0]}:`];
						l['log_status'] = logs[1].trim();
					} else {
						l['booking'] = true;

						const log_arr = [];
						const logs = l.log_info.split('\r');
						
						logs.forEach(log => {
							if (log.length !== 0) {
								if (log.includes(':')) {
									const log_split_arr = log.split(':');
									const logs_value = log_split_arr && log_split_arr.length !== 0 && log_split_arr[1] && log_split_arr[1].length !== 0 ? log_split_arr[1].split('->') : [];
								
									const obj = {
										key: log_split_arr[0].trim(),
										last: logs_value[0] && logs_value[0].length !== 0 ? logs_value[0].trim() : '',
										current: logs_value[1] && logs_value[1].length !== 0 ? logs_value[1].trim() : '',
									};

									log_arr.push(obj);
								} else {
									log_arr.push(log.trim());
								}
							}
						});
						l['log'] = log_arr;
						l['log_status'] = '';
					}
				});
			}

			return log;
		}
	},
	methods: {
		getHistoryByRefID(ref_id) {
			this.loading = true;

			let url = `/api/media/media_planning/import_export/holding_items_log`;

			const params = [];
			params.push("mediaref=" + ref_id);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.history_log = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		},
	}
}	
</script>

<style scoped>
.title-text {
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.time-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(25, 42, 62, 0.5);
}
.context-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
</style>
